import { FieldMetaProps } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const ErrorI18n = ({ error, touched }: FieldMetaProps<any>) => {
  const { t } = useTranslation(['translation']);

  return error && touched ? <Form.Control.Feedback type="invalid">{t(error)}</Form.Control.Feedback> : <></>;
};
